import { LifeSphere } from '../types';

export const donskojSpheres3: LifeSphere[] = [
  {
    id: 'ds6',
    productId: '10',
    name: 'Энергетика и жизненные силы',
    description: 'Упадок сил, энергетическое истощение, восстановление энергии, вибрации',
    themes: [{
      id: 'cat_ds6',
      sphereId: 'ds6',
      name: 'Энергетика и жизненные силы',
      description: '',
      subthemes: [
        {
          id: 'dt6_01',
          themeId: 'cat_ds6',
          name: 'Хроническая усталость',
          description: 'Постоянное чувство усталости, отсутствие энергии даже после отдыха, невозможность восстановиться',
          units: [
          ],
        },
        {
          id: 'dt6_02',
          themeId: 'cat_ds6',
          name: 'Упадок сил после 40',
          description: 'Возрастная потеря энергии, ощущение что тело сдаёт, климакс и гормоны',
          units: [
          ],
        },
        {
          id: 'dt6_03',
          themeId: 'cat_ds6',
          name: 'Энергетические вампиры',
          description: 'Люди, которые забирают энергию, токсичное окружение, невозможность защититься',
          units: [
          ],
        },
        {
          id: 'dt6_04',
          themeId: 'cat_ds6',
          name: 'Низкие вибрации',
          description: 'Состояние подавленности, тяжести, негативного мышления, притяжение негатива',
          units: [
          ],
        },
        {
          id: 'dt6_05',
          themeId: 'cat_ds6',
          name: 'Эмоциональное истощение',
          description: 'Выгорание от эмоциональных нагрузок, перегрузка чувствами',
          units: [
          ],
        },
        {
          id: 'dt6_06',
          themeId: 'cat_ds6',
          name: 'Потеря жизненной энергии',
          description: 'Ощущение что жизненная сила уходит, внутренняя пустота, отсутствие драйва',
          units: [
          ],
        },
        {
          id: 'dt6_07',
          themeId: 'cat_ds6',
          name: 'Быстрая утомляемость',
          description: 'Малейшая нагрузка вызывает усталость, нехватка выносливости',
          units: [
          ],
        },
        {
          id: 'dt6_08',
          themeId: 'cat_ds6',
          name: 'Сезонная хандра',
          description: 'Зимняя депрессия, осенняя хандра, зависимость настроения от погоды и света',
          units: [
          ],
        },
        {
          id: 'dt6_09',
          themeId: 'cat_ds6',
          name: 'Нет сил на семью после работы',
          description: 'Работа забирает все ресурсы, на близких ничего не остаётся',
          units: [
          ],
        },
        {
          id: 'dt6_10',
          themeId: 'cat_ds6',
          name: 'Синдром хронической усталости',
          description: 'Медицинский аспект хронической усталости, поиск диагноза и лечения',
          units: [
          ],
        },
        {
          id: 'dt6_11',
          themeId: 'cat_ds6',
          name: 'Невозможность сосредоточиться',
          description: 'Рассеянность, проблемы с концентрацией, мозговой туман',
          units: [
          ],
        },
        {
          id: 'dt6_12',
          themeId: 'cat_ds6',
          name: 'Потеря мотивации',
          description: 'Отсутствие мотивации, нежелание действовать, лень как симптом',
          units: [
          ],
        },
        {
          id: 'dt6_13',
          themeId: 'cat_ds6',
          name: 'Зависимость от кофе и стимуляторов',
          description: 'Невозможность функционировать без кофе, энергетиков, сахара',
          units: [
          ],
        },
        {
          id: 'dt6_14',
          themeId: 'cat_ds6',
          name: 'Восстановление после стресса',
          description: 'Невозможность прийти в себя после тяжёлых событий, долгое восстановление',
          units: [
          ],
        },
        {
          id: 'dt6_15',
          themeId: 'cat_ds6',
          name: 'Энергетическая защита',
          description: 'Потребность в защите своей энергии, границы, практики защиты',
          units: [
          ],
        },
      ],
    }],
  },
  {
    id: 'ds7',
    productId: '10',
    name: 'Внешность и уверенность в себе',
    description: 'Лишний вес, внешний вид, самооценка, принятие себя, красота и молодость',
    themes: [{
      id: 'cat_ds7',
      sphereId: 'ds7',
      name: 'Внешность и уверенность в себе',
      description: '',
      subthemes: [
        {
          id: 'dt7_01',
          themeId: 'cat_ds7',
          name: 'Лишний вес и невозможность похудеть',
          description: 'Борьба с весом, диеты, эмоциональное переедание, наследственность',
          units: [
          ],
        },
        {
          id: 'dt7_02',
          themeId: 'cat_ds7',
          name: 'Преждевременное старение',
          description: 'Страх старости, увядание, потеря молодости раньше времени',
          units: [
          ],
        },
        {
          id: 'dt7_03',
          themeId: 'cat_ds7',
          name: 'Проблемы с кожей',
          description: 'Акне, высыпания, аллергии, нездоровый цвет лица, психосоматика кожи',
          units: [
          ],
        },
        {
          id: 'dt7_04',
          themeId: 'cat_ds7',
          name: 'Выпадение волос',
          description: 'Потеря волос, облысение, истончение, связь с внутренним состоянием',
          units: [
          ],
        },
        {
          id: 'dt7_05',
          themeId: 'cat_ds7',
          name: 'Осанка и походка',
          description: 'Сутулость, зажатость тела, связь осанки с уверенностью',
          units: [
          ],
        },
        {
          id: 'dt7_06',
          themeId: 'cat_ds7',
          name: 'Неудовлетворённость внешностью',
          description: 'Общее недовольство своей внешностью, невозможность принять себя',
          units: [
          ],
        },
        {
          id: 'dt7_07',
          themeId: 'cat_ds7',
          name: 'Комплексы по поводу тела',
          description: 'Телесные комплексы, стыд за своё тело, невозможность расслабиться',
          units: [
          ],
        },
        {
          id: 'dt7_08',
          themeId: 'cat_ds7',
          name: 'Целлюлит и растяжки',
          description: 'Борьба с целлюлитом и растяжками, стыд, бесполезность процедур',
          units: [
          ],
        },
        {
          id: 'dt7_09',
          themeId: 'cat_ds7',
          name: 'Отёки и одутловатость',
          description: 'Отёчность лица и тела, задержка жидкости, одутловатый вид',
          units: [
          ],
        },
        {
          id: 'dt7_10',
          themeId: 'cat_ds7',
          name: 'Морщины и возрастные изменения',
          description: 'Появление морщин, носогубных складок, изменение овала лица',
          units: [
          ],
        },
        {
          id: 'dt7_11',
          themeId: 'cat_ds7',
          name: 'Сравнение себя с другими',
          description: 'Постоянное сравнение с окружающими, зависть к чужой красоте и успеху',
          units: [
          ],
        },
        {
          id: 'dt7_12',
          themeId: 'cat_ds7',
          name: 'Зависимость от чужого мнения о внешности',
          description: 'Потребность в одобрении, страх критики, зависимость от оценки окружающих',
          units: [
          ],
        },
        {
          id: 'dt7_13',
          themeId: 'cat_ds7',
          name: 'Страх раздеться на пляже',
          description: 'Конкретный триггер — ситуации, где нужно показать тело: пляж, бассейн, примерочная',
          units: [
          ],
        },
        {
          id: 'dt7_14',
          themeId: 'cat_ds7',
          name: 'Внутренняя красота vs внешняя',
          description: 'Поиск баланса между внешним и внутренним, понимание истинной красоты',
          units: [
          ],
        },
        {
          id: 'dt7_15',
          themeId: 'cat_ds7',
          name: 'Омоложение через работу с подсознанием',
          description: 'Идея что мысли и подсознание влияют на внешность и процесс старения',
          units: [
          ],
        },
      ],
    }],
  },
];